import { apiFetch } from "./api";

export function fetchAdminResources(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null || value === undefined || value === "") return;
    search.set(key, value);
  });
  const query = search.toString() ? `?${search.toString()}` : "";
  return apiFetch(`/api/v1/admin/resources${query}`);
}
